import React from "react";

const ComponentImage = ({ options }) => {
  //Des
  const { objinfo = {} } = options;
  const { content = {} } = objinfo || {};
  return (
    <div className="slide academy-slide slider-img">
      <img src={content.url_cotent} alt="" loading="lazy" decoding="async" />
    </div>
  );
};

export default ComponentImage;
